import { FC, useEffect, useState } from "react";
import {
  Dropdown,
  Menu,
  Space,
  Table,
  Typography,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  ParkingListItems,
} from "services/interface";
import { formatDateWithTime } from "utils/dateFormat";
// import { useGetOrderDetail } from "hooks/useOrders";
import { useAppDispatch, useAppSelector } from "../../../store";
import { useNavigate } from "react-router-dom";
import { EllipsisOutlined } from "@ant-design/icons";

interface OrderTableListProps {
  // data?: GetDataOrderListData;
  // IsHiddenPersonInfo?: boolean;
  // refetchData: () => void;
  // childrenBank: React.ReactNode[];
  data:  ParkingListItems[] | undefined;
  // id: string;
  onDeleteData:  (id: string) => void;
  onEditData:  (id: string) => void;
}

const OrderTableList: FC<OrderTableListProps> = ({
  // id,
  data,
  onDeleteData,
  onEditData
  // IsHiddenPersonInfo,
  // refetchData,
  // childrenBank,
}) => {
  const navigate = useNavigate();
  const tabsKey = 3;
  const dispatch = useAppDispatch();
  const offset = useAppSelector((state) => state.order.dataComplete.offset);
  const limit = useAppSelector((state) => state.order.dataComplete.limit);
  // const [showDetail, setShowDetail] = useState(false);
  // const [modalData, setModalData] = useState<GetOrderDetailData>();
  // const { mutate } = useGetOrderDetail();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(Math.floor(offset / limit) + 1);
  }, [offset, limit]);

  const columns: ColumnsType<ParkingListItems> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "ชื่อจุดจอด",
      dataIndex: "name",
      render: (_text) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
            }}
            type="secondary"
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "create_date",
      render: (_text) => {
        return (
          <Typography>
            {_text ? formatDateWithTime(_text) : '-'}
          </Typography>
        );
      },
    },
    {
      title: "วันที่แก้ไข",
      dataIndex: "update_date",
      render: (_text) => {
        return (
          <Typography>
            {_text ? formatDateWithTime(_text) : '-'}
          </Typography>
        );
      },
    },
    {
      title: "Action",
      align: "center",
      fixed: 'right',
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      onEditData(record.id);
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteData(record.id);
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];

  // let filtersColumns: (
  //   | ColumnGroupType<GetDataOrderListItems>
  //   | ColumnType<GetDataOrderListItems>
  // )[] = columns;
  // if (IsHiddenPersonInfo) {
  //   filtersColumns = columns.filter(
  //     (column) => column.key !== "ref_name" && column.key !== "ref_telephone"
  //   );
  // }
  
  return (
    <div>
      <Table
        rowKey="order_id"
        size="small"
        columns={columns}
        dataSource={data}
        pagination={{
          current: currentPage,
          pageSize: limit,
          // total: parseInt(data?.total_record as string),
          onChange: (page, pageSize) => {
            // dispatch(setDataCompleteOffset(pageSize! * (page! - 1)));
            // dispatch(setDataCompleteLimit(pageSize!));
          },
        }}
        scroll={{x:true}}
      />
      {/* <Modal
        title="แก้ไขรายการจุดส่ง"
        open={showDetail}
        maskClosable={false}
        onCancel={()=> {
          setShowDetail(false);
        }}
        style={{ top: 20 }}
        footer={[
          <Button key="back" >
            ยกเลิก
          </Button>,
          <Button key="submit" type="primary" >
            บันทึกการแก้ไข
          </Button>
        ]}
      >
      </Modal> */}
    </div>
  );
};

export default OrderTableList;
